import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import classnames from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import Dropzone from 'react-dropzone-uploader';

// API YAPILANDIRMASI
const API_BASE_URL = "https://tazelyapi.stechomeyazilim.info";
const CATEGORY_ENDPOINT = `${API_BASE_URL}/Product_Category`;
  const IMAGE_BASE_URL = 'https://bittigittipreview.stechomeyazilim.info/';
  const UPLOAD_URL = 'https://bittigitti.online:9024/uploadfile';

const ContactsList = props => {
  document.title = "Ürün Kategorileri | Tazelya ADMIN PANELI";

  const [categories, setCategories] = useState([]);
  const [contactEdit, setEditContact] = useState(null);
  const [getFileName, setFileName] = useState('');
  const [getIconName, setIconName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  
  // Dil Tabları için state
  const [activeTab, setActiveTab] = useState("1");

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${CATEGORY_ENDPOINT}`);
      setCategories(response.data.value || response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Veri çekme hatası:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // --- FORM İŞLEMLERİ ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: (contactEdit && contactEdit.Product_Category_Title) || "",
      title_en: (contactEdit && contactEdit.Product_Category_Title_En) || "",
      title_ar: (contactEdit && contactEdit.Product_Category_Title_Ar) || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Türkçe kategori başlığını giriniz"),
    }),
    onSubmit: async (values) => {
      const payload = {
        Product_Category_Title: values.title,
        Product_Category_Title_En: values.title_en,
        Product_Category_Title_Ar: values.title_ar,
        Image: getFileName,
        Product_Category_Icon: getFileName,
      };

      try {
        if (isEdit) {
          await axios.patch(`${CATEGORY_ENDPOINT}(${contactEdit.ID})`, payload);
        } else {
          await axios.post(CATEGORY_ENDPOINT, payload);
        }
        toggle();
        fetchCategories();
      } catch (error) {
        console.error("Kaydetme hatası:", error);
        alert("İşlem başarısız oldu.");
      }
    },
  });

  // --- SİLME İŞLEMİ ---
  const handleDeleteCategory = async () => {
    try {
      await axios.delete(`${CATEGORY_ENDPOINT}(${selectedId})`);
      setDeleteModal(false);
      fetchCategories();
    } catch (error) {
      console.error("Silme hatası:", error);
    }
  };

  // --- TABLO KOLONLARI ---
  const columns = useMemo(() => [
    { Header: "ID", accessor: "ID" },
    {
      Header: "Görsel",
      disableFilters: true,
      accessor: (row) => (
        <div className="avatar-xs">
          {row.Image ? (
            <img className="rounded-circle avatar-xs" src={`${IMAGE_BASE_URL}${row.Product_Category_Icon}`} alt="" />
          ) : (
            <span className="avatar-title rounded-circle">{row.Product_Category_Title?.charAt(0)}</span>
          )}
        </div>
      ),
    },
    {
      Header: "Kategori Başlığı (TR)",
      accessor: "Product_Category_Title",
      Cell: cellProps => <NameSurname {...cellProps} />,
    },
    {
        Header: "Kategori Başlığı (EN)",
        accessor: "Product_Category_Title_En",
    },
    {
      Header: "İşlemler",
      Cell: cellProps => (
        <div className="d-flex gap-3">
          <Link to="#" className="text-success" onClick={() => handleEditClick(cellProps.row.original)}>
            <i className="mdi mdi-pencil font-size-18" />
          </Link>
          <Link to="#" className="text-danger" onClick={() => handleDeleteClick(cellProps.row.original.ID)}>
            <i className="mdi mdi-delete font-size-18" />
          </Link>
        </div>
      ),
    },
  ], []);

  const toggle = () => {
    setModal(!modal);
    if (!modal) {
      setEditContact(null);
      setFileName('');
      setIconName('');
      setIsEdit(false);
      setActiveTab("1"); // Kapatınca ilk taba dön
    }
  };

  const handleEditClick = (data) => {
    setEditContact(data);
    setFileName(data.Image || '');
    setIconName(data.Product_Category_Icon || '');
    setIsEdit(true);
    setModal(true);
  };

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };

  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: UPLOAD_URL, body };
  };

  const handleChangeImageStatus = ({ xhr }) => {
    if (xhr && xhr.readyState === 4) {
      const result = JSON.parse(xhr.response);
      setFileName(result.file.filename);
    }
  };

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box p-2 border mb-2">
        <img src={previewUrl} style={{ height: '50px' }} alt="preview" /> 
        <span className="ms-2">{name} - {status === "done" ? "Hazır" : `%${Math.round(percent)}`}</span>
      </div>
    );
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteCategory}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="E-Ticaret" breadcrumbItem="Ürün Kategorileri" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={categories}
                    isGlobalFilter={true}
                    isAddRestCategory={true} 
                    handleOrderClicks={() => { setIsEdit(false); setModal(true); }}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modal} toggle={toggle} size="lg">
                    <ModalHeader toggle={toggle} tag="h4">
                      {isEdit ? "Kategoriyi Düzenle" : "Yeni Kategori Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                        
                        {/* Dil Tabları Navigasyonu */}
                        <Nav tabs className="nav-tabs-custom nav-justified">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({ active: activeTab === "1" })}
                              onClick={() => setActiveTab("1")}
                            >
                              <span className="d-none d-sm-block">Türkçe</span>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({ active: activeTab === "2" })}
                              onClick={() => setActiveTab("2")}
                            >
                              <span className="d-none d-sm-block">English</span>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({ active: activeTab === "3" })}
                              onClick={() => setActiveTab("3")}
                            >
                              <span className="d-none d-sm-block">العربية</span>
                            </NavLink>
                          </NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab} className="p-3 text-muted">
                          {/* Türkçe Tab */}
                          <TabPane tabId="1">
                            <div className="mb-3">
                              <Label>Kategori Başlığı (TR)</Label>
                              <Input
                                name="title"
                                type="text"
                                placeholder="Örn: Meyve & Sebze"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title}
                                invalid={validation.touched.title && !!validation.errors.title}
                              />
                              <FormFeedback>{validation.errors.title}</FormFeedback>
                            </div>
                          </TabPane>

                          {/* English Tab */}
                          <TabPane tabId="2">
                            <div className="mb-3">
                              <Label>Category Title (EN)</Label>
                              <Input
                                name="title_en"
                                type="text"
                                placeholder="e.g. Fruits & Vegetables"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title_en}
                              />
                            </div>
                          </TabPane>

                          {/* Arabic Tab */}
                          <TabPane tabId="3">
                            <div className="mb-3">
                              <Label className="d-block text-end">العنوان (AR)</Label>
                              <Input
                                name="title_ar"
                                type="text"
                                dir="rtl"
                                placeholder="مثال: خضروات وفواكه"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title_ar}
                              />
                            </div>
                          </TabPane>
                        </TabContent>

                        <Row className="p-3">
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label>Kategori Görseli</Label>
                              <Dropzone
                                getUploadParams={getUploadParams}
                                onChangeStatus={handleChangeImageStatus}
                                maxFiles={1}
                                multiple={false}
                                canRemove={true}
                                accept="image/*"
                                PreviewComponent={Preview}
                                inputContent="Görseli buraya sürükleyin"
                                styles={{ dropzone: { minHeight: 120, border: '2px dashed #ced4da' } }}
                              />
                              {getFileName && <p className="text-success mt-1">Yüklü: {getFileName}</p>}
                            </div>
                          </Col>
                        </Row>

                        <div className="text-end p-3">
                          <button type="submit" className="btn btn-primary w-md">
                            {isEdit ? "Güncelle" : "Kaydet"}
                          </button>
                        </div>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);